import React from "react";
import { IconExtras } from "@trainline/depot-web";
import * as styles from "./PaidTicketOptionsFooter.module.css";
import PassengerTicketOptionsList from "./PassengerTicketOptionsList";
import TransitLegFooter from "./TransitLegFooter";
const PaidTicketOptionsFooter = ({ extras }) => {
  return /* @__PURE__ */ React.createElement(TransitLegFooter, {
    labelMessage: "transitLeg.ticketOptions",
    icon: /* @__PURE__ */ React.createElement(IconExtras, {
      className: styles.icon
    }),
    content: /* @__PURE__ */ React.createElement(PassengerTicketOptionsList, {
      extras
    })
  });
};
var PaidTicketOptionsFooter_default = PaidTicketOptionsFooter;
export {
  PaidTicketOptionsFooter_default as default
};
